<template>
  <el-dialog title="详情" ref="dialog">
    <div>
      <el-table :data="currentInfo" :show-header="false">
        <el-table-column prop="label"></el-table-column>
        <el-table-column>
          <template scope="scope">
            <!-- 姓名 -->
            <span v-if="scope.$index === 0">{{scope.row.name}}</span>
            <!-- 职位 -->
            <span v-if="scope.$index === 1">{{scope.row.position}}</span>
            <!-- 部门 -->
            <span v-if="scope.$index === 2">{{scope.row.structure}}</span>
            <!-- 手机 -->
            <span v-if="scope.$index === 3">{{scope.row.mobile}}</span>
            <!-- 详情 -->
            <div v-if="scope.$index === 4" class="mh-270 ovf-auto">
              <div v-for="option in scope.row.leave_list" class="m-b-5">
                <span style="font-weight: 800;">{{option.type}}:</span><span>{{option.hours}}</span><br/>
                <span>{{option.start}}</span>~<span>{{option.end}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>
<script>
import http from 'assets/js/http'
export default {
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    startTime: {
      default() {
        return ''
      }
    },
    endTime: {
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      currentInfo: [
        {
          label: '姓名',
          name: ''
        }, {
          label: '职位',
          position: ''
        }, {
          label: '部门',
          structure: ''
        }, {
          label: '手机',
          mobile: ''
        }, {
          label: '详情',
          leave_list: []
        }
      ]
    }
  },
  methods: {
    async openDialog() {
      await this.getDetail()
      setTimeout(() => {
        this.$refs.dialog.open()
      }, 200)
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    async getDetail() {
      let input = {
        name: this.name,
        time_start: this.startTime,
        time_end: this.endTime
      }
      await this.apiPost('custom/leave/statistics/detail', input).then((res) => {
        if (res.code === 200) {
          this.currentInfo[0].name = res.data.name
          this.currentInfo[1].position = res.data.position
          this.currentInfo[2].structure = res.data.structure
          this.currentInfo[3].mobile = res.data.mobile
          this.currentInfo[4].leave_list = res.data.leave_list
        }
      })
    }
  },
  mixins: [http]
}
</script>




// WEBPACK FOOTER //
// leaveInfoDialog.vue?59d7e6e6